// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-b5145a06] .el-dialog{margin-top:10vh!important;width:1060px!important;max-height:800px!important;overflow-y:auto}.btn-delCertResume[data-v-b5145a06]{color:#f56c6c}.btn-cancel[data-v-b5145a06]{color:#e6a23c}.upload-demo[data-v-b5145a06]{display:inline-block;margin-left:10px}[data-v-b5145a06] .page-bar{margin-bottom:0;margin-top:10px}[data-v-b5145a06] .el-table td{padding:2px 0}", ""]);
// Exports
module.exports = exports;
